import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-last-menu-element',
  templateUrl: './last-menu-element.component.html',
  styleUrls: ['./last-menu-element.component.css']
})
export class LastMenuElementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
